<template>
  <article>
    <Content>
      <h1>{{ $t('header_welcome') }}</h1>
      <hr />
      <template v-if="isLoggedIn">
        <p>
          <b>{{ $t('you_are_logged_in_as') }}</b
          ><br />
          {{ profile.email }}
        </p>
        <Alert :iconSrc="iconBulb">
          <b> {{ $t('exam_session_instructions_header') }} </b><br />
          {{ $t('exam_session_instructions_body') }}
        </Alert>
        <Alert :iconSrc="iconEye">
          <b> {{ $t('camera_status_header') }} </b><br />
          <template v-if="!error && accessToCamera">
            {{ $t('camera_status_accepted') }}
            <WhyVideoModal />
          </template>
          <template v-else-if="errNoRecorder">
            {{ $t('alert_unsupported_media_recorder') }}
            <WhyVideoModal />
          </template>
          <template v-else-if="errBelowSpec">
            {{ $t('camera_status_overconstrained') }}
            <WhyVideoModal />
          </template>
          <template v-else-if="errUserDenied">
            {{ $t('camera_status_blocked') }}
            <WhyVideoModal />
          </template>
          <template v-else>
            {{ $t('camera_status_dismissed') }}
            <WhyVideoModal />
            <Button to="/video-check" class="check-cam">{{
              $t('button_check_camera')
            }}</Button>
          </template>
        </Alert>
      </template>
      <p v-else>
        <router-link to="/login">{{
          $t('generic_log_in_message')
        }}</router-link>
      </p>
    </Content>

    <Content v-if="isLoggedIn">
      <Activities v-if="hasActivities" />
      <div v-else>{{ $t('generic_loading_message') }}...</div>
    </Content>
  </article>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { Content, Alert, Button } from '@neurotrack/web-shared-components'
import Activities from '@/components/Activities'
import iconBulb from '@/assets/svg/icon-light-bulb.svg'
import iconEye from '@/assets/svg/icon-eye.svg'
import WhyVideoModal from './WhyVideoModal.vue'

export default {
  name: 'Home',
  data() {
    return {
      iconBulb,
      iconEye
    }
  },
  components: {
    Content,
    Activities,
    Alert,
    Button,
    WhyVideoModal
  },
  beforeMount() {
    this.resetActivities()
  },
  async mounted() {
    const userId = this.profile.user_id

    if (!userId) {
      await this.$router.push('/login')
    } else {
      let path = '/'
      if (
        !this.userDeclinedCamera
        && !this.accessToCamera
        && !this.errNoRecorder
      ) {
        path = '/preamble'
      }
      if (!this.hasCompleteProfile) {
        path = `/profile?rqd=true&redirect=${path}`
      }
      if (path !== '/') {
        await this.$router.push(path)
        return
      }
      await this.getActivities(userId)
    }
  },
  methods: {
    ...mapActions('activities', ['getActivities', 'resetActivities'])
  },
  computed: {
    ...mapState('user', ['profile', 'hasCompleteProfile']),
    ...mapState('activities', ['activities']),
    ...mapState('video', [
      'accessToCamera',
      'userDeclinedCamera',
      'error',
      'errUserDenied',
      'errUserDismissed',
      'errBelowSpec',
      'errNoRecorder'
    ]),
    ...mapGetters('user', ['isLoggedIn']),
    hasActivities() {
      return this.activities && this.activities.length > 0
    }
  }
}
</script>

<style scoped>
.check-cam {
  margin: 1rem 0;
}
</style>
